import { FieldProps, Textarea, TextareaProps } from '@optimus-web/core';
import { ControllerProps, useControllerWithEventHandler } from '../hooks';

export type FormTextareaFieldProps = Omit<TextareaProps & FieldProps, 'value' | 'error' | 'onBlur'> &
    ControllerProps<string | undefined>;

export const FormTextareaField = ({
    defaultValue,
    name,
    onChange,
    rules,
    shouldUnregister,
    transform,
    ...other
}: FormTextareaFieldProps) => {
    const { value, error, handleChange, onBlur, context } = useControllerWithEventHandler({
        defaultValue,
        name,
        onChange,
        rules,
        shouldUnregister,
        transform,
    });
    const props = {
        ...other,
        error,
        name,
        onBlur,
        onChange: handleChange,
        value,
        readOnly: context?.readOnly || other.readOnly,
    };

    return <Textarea {...props} />;
};
